import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSelector, useDispatch } from 'react-redux';
import { closeInAppNoti } from '../../Reducer/InAppNotiReducer';
import NOTI_PRESET from '../../Presets/NotiPreset';
import { BaseInfoActions } from '../../Reducer/BaseInfoReducer';
import Icon from '../../Assets/Icon/CustomIcons';

const ICON_MAP = {
  Alarm: <Icon.Alarm />,
};

export default function InAppNoti() {
  const dispatch = useDispatch();
  const { open, title, message, icon, gubun, responseData } = useSelector(
    (state) => state.inAppNoti
  );

  // 자동 닫힘
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => dispatch(closeInAppNoti()), 4000);
      return () => clearTimeout(timer);
    }
  }, [open]);

  // 페이지 이동
  // const handleClick = () => {
  //   dispatch(closeInAppNoti());
  //   dispatch(BaseInfoActions.setFcmReceptionPayload({}));
  //   const preset = NOTI_PRESET[gubun] || NOTI_PRESET.default;

  //   const route = preset.buildRoute(responseData);
  //   window.location.href = route;
  // };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 60, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 25 }}
          // onClick={handleClick}
          style={{
            position: 'fixed',
            bottom: 25,
            left: 100,
            margin: '0 auto',
            width: '20%',
            minWidth: 300,
            maxWidth: 400,
            background: '#333',
            color: '#fff',
            borderRadius: 12,
            padding: '12px 14px',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            zIndex: 3000,
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            cursor: 'pointer',
            opacity: 0.95,
          }}
        >
          <div
            style={{
              width: 40,
              height: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {ICON_MAP[icon || 'Alarm']}
          </div>

          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 'bold', fontSize: 14 }}>{title}</div>
            <div style={{ fontSize: 13, opacity: 0.9 }}>{message}</div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
